<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Переменные в документах</h2>
      <div class="btn-group float-right" role="group">
        <template v-if="!reorder">
          <button class="compose btn btn-secondary" @click="switchReorder()">Изменить порядок</button>
          <button class="compose btn btn-success" @click="copyFromAnotherProject()">Скопировать из другого проекта</button>
          <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
        </template>
        <template v-else>
          <button class="compose btn btn-danger" @click="switchReorder()">Отмена</button>
          <button class="compose btn btn-success" @click="saveOrder()">Сохранить</button>
        </template>
      </div>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="!reorder">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
            <tr>
              <th style="width: 5%;">#</th>
              <th style="width: 30%;">Наименование</th>
              <th style="width: 10%;">Категория</th>
              <th style="width: 20%;">Значение по умолчанию</th>
              <th style="width: 30%;">Описание</th>
              <th style="width: 30%;">Тэг</th>
              <th style="width: 5%;">Действия</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="fields.length > 0">
              <tr v-for="(field, index) in fields">
                <td>{{index + 1}}</td>
                <td>{{field.name}}</td>
                <td>{{field.category ? field.category.name : ''}}</td>
                <td>{{field.default_value}}</td>
                <td>{{field.description}}</td>
                <td>{{tags[field.tag]}}</td>
                <td>
                  <div class="btn-group">
                    <a class="btn btn-sm btn-primary" @click.prevent="editRecord(field)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                    <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(field.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="6">
                  Нет данных для отображения
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>
    <div class="card" v-if="reorder">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">

            <draggable group="fields" :list="fields">
              <tr v-for="(field, index) in fields" :key="field.id" style="cursor: pointer;">
                <td><font-awesome-icon icon="fas fa-arrows" size="2x" /></td>
                <td>{{index + 1}}</td>
                <td>{{field.name}}</td>
                <td>{{field.category ? field.category.name : ''}}</td>
                <td>{{field.default_value}}</td>
                <td>{{field.description}}</td>
                <td>{{tags[field.tag]}}</td>
              </tr>
            </draggable>

          </table>
        </div>
      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title" v-show="!editmode">Добавить</h5>
            <h5 class="modal-title" v-show="editmode">Редактировать</h5>
          </div>
          <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Выберите категорию</label>
                <v-select v-model="recordform.category_id" label="name" :reduce="category => category.id" :options="categories" />
              </div>
              <div class="form-group">
                <label>Наименование</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Значение по умолчанию</label>
                <input v-model="recordform.default_value" type="text" placeholder="Значение по умолчанию" class="form-control">
              </div>
              <div class="form-group">
                <label>Описание</label>
                <input v-model="recordform.description" type="text" placeholder="Описание" class="form-control">
              </div>
              <div class="form-group">
                <label>Тэг</label>
                <v-select v-model="recordform.tag" label="value" :reduce="tag => tag.key" :options="tagsOptions" />
              </div>
              <div class="form-check">
                <input v-model="recordform.creationAvailable" type="checkbox" placeholder="Доступно для создания" class="form-check-input">
                <label class="form-check-label">Доступно для создания</label>
              </div>
              <div class="form-check">
                <input v-model="recordform.changeAvailable" type="checkbox" placeholder="Доступно для изменения" class="form-check-input">
                <label class="form-check-label">Доступно для изменения</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="copyForm" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title">Копирование из другого проекта</h5>
          </div>
          <form @submit.prevent="copyRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Выберите проект</label>
                <v-select v-model="copyform.project_id" label="short_name" :reduce="project => project.id" :options="$parent.$parent.projects" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button type="submit" class="btn btn-primary">Скопировать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  props: ['id', 'project'],
  computed: {
    startPage() {
      if (this.currentPage < 4) {
        return 1;
      }
      if (this.currentPage == this.lastPage) {
        return this.startPage2;
      }

      if ((this.currentPage + 1) == this.lastPage) {
        return this.startPage2;
      }

      if ((this.currentPage + 2) == this.lastPage) {
        return this.startPage2;
      }
      return this.currentPage - 3;
    },
    startPage2(){
      if(this.lastPage > 6){
        return this.lastPage - 6;
      }
      if(this.lastPage > 5){
        return this.lastPage - 5;
      }
      if(this.lastPage > 4){
        return this.lastPage - 4;
      }
      if(this.lastPage > 3){
        return this.lastPage - 3;
      }
      if(this.lastPage > 2){
        return this.lastPage - 2;
      }
    },
    visiblePages() {
      let pages = [];
      let start = this.startPage;
      let end = Math.min(this.startPage + 6, this.lastPage);
      for (let i = start; i <= end; i++) {
        pages.push({
          name: i,
          active: i == this.currentPage
        });
      }
      return pages;
    }
  },
  data () {
    return {
      reorder: false,
      searchQuery: '',
      currentPage: 1,
      lastPage: 1,
      firstPage: 1,
      timeout: null,
      perPage: 50,
      perPageList: [10, 25, 50, 100],
      categories: [],
      tags: {
        DOCS_DATE: 'Дата всех документов',
        ISPDN: 'Название ИСПДн',
        DOC_NUMBER: 'Номер договора',
        SHORT_COMPANY_NAME: 'Краткое название организации',
        PACKAGE_NUMBER: 'Номер пакета',
        ATTESTATION_NUMBER: 'Номер аттестации',
      },
      tagsOptions: [],
      fields: [],
      recordform: new Form({
        id: null,
        name: null,
        category_id: null,
        default_value: null,
        description: null,
        tag: null,
        creationAvailable: true,
        changeAvailable: true,
      }),
      copyform: new Form({
        project_id: null
      }),
      editmode: false,
    }
  },
  mounted() {
    this.tagsOptions = Object.entries(this.tags).map(([key, value]) => ({ key, value }));
  },
  methods: {
    saveOrder(){
      this.$Progress.start();
      let fields = [];
      this.fields.forEach((item, key) => {
        fields.push({id: item.id, sort: key})
      });
      const data = new FormData();
      data.append('fields', JSON.stringify(fields));
      axios.post('/api/project/'+this.id+'/field/resort', data)
          .then((response) => {
            this.reorder = false;
            this.loadRecords();
            this.SuccessToast();
            this.$Progress.finish();
          })
          .catch(() => {
            this.ErrorToast();
            this.$Progress.fail();
          });
    },
    switchReorder(){
      if(!this.reorder){
        this.loadAllRecords();
      }else{
        this.loadRecords();
      }
      this.reorder = !this.reorder;
    },
    copyFromAnotherProject(){
      $('#copyForm').modal('show');
    },
    copyRecord(){
      this.$Progress.start();
      this.copyform.post('/api/project/'+this.id+'/field/copy')
          .then((response)=>{
            $('#copyForm').modal('hide');
            this.SuccessToast();
            this.loadRecords();
            this.loadCategories();
            this.copyform.reset();
            this.$Progress.finish();
          })
          .catch(()=>{
            this.ErrorToast();
            this.$Progress.fail();
          })
    },
    SuccessToast(){
      Toast.fire({
        icon: 'success',
        title: 'Успешно'
      });
    },
    ErrorToast(){
      Toast.fire({
        icon: 'error',
        title: 'Ошибка'
      });
    },
    editRecord(record){
      this.editmode = true;
      this.recordform.reset();
      this.recordform.id = record.id;
      this.recordform.name = record.name;
      this.recordform.category_id = record.category_id;
      this.recordform.default_value = record.default_value;
      this.recordform.description = record.description;
      this.recordform.tag = record.tag;
      this.recordform.creationAvailable = record.creationAvailable;
      this.recordform.changeAvailable = record.changeAvailable;
      $('#addNewRecord').modal('show');
    },
    newRecord(){
      this.editmode = false;
      this.recordform.reset();
      $('#addNewRecord').modal('show');
    },
    nextPage(){
      if(this.currentPage < this.lastPage){
        this.currentPage++;
        this.loadRecords();
      }
    },
    selectPage(number){
      this.currentPage = number;
      this.loadRecords();
    },
    prevPage(){
      if(this.currentPage > 1){
        this.currentPage--;
        this.loadRecords();
      }
    },
    search(){
      if(this.timeout)
        clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$Progress.start();
        this.currentPage = 1;
        this.loadRecords();
        this.$Progress.finish();
      }, 500);

    },
    changePerPage(){
      this.currentPage = 1;
      this.loadRecords();
    },
    createRecord(){
      this.$Progress.start();
      this.recordform.post('/api/project/'+this.id+'/field')
          .then((response)=>{
            $('#addNewRecord').modal('hide');
            this.SuccessToast();
            this.loadRecords();
            this.recordform.reset();
            this.$Progress.finish();
          })
          .catch(()=>{
            this.ErrorToast();
            this.$Progress.fail();
          })
    },
    updateRecord(){
      this.$Progress.start();
      this.recordform.put('/api/project/'+this.id+'/field/'+this.recordform.id)
          .then((response) => {
            $('#addNewRecord').modal('hide');
            this.SuccessToast();
            this.loadRecords();
            this.recordform.reset();
            this.$Progress.finish();
          })
          .catch(() => {
            this.ErrorToast();
            this.$Progress.fail();
          });
    },
    deleteRecord(id){
      Swal.fire({
        title: 'Вы уверены?',
        text: "Это действие нельзя будет отменить",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Да, удалить'
      }).then((result) => {
        if (result.value) {
          this.recordform.delete('/api/project/'+this.id+'/field/'+id).then(()=>{
            this.SuccessToast();
            this.loadRecords();
          }).catch((data)=> {
            this.ErrorToast();
          });
        }
      })
    },
    loadAllRecords(){
      axios.get('/api/project/'+this.id+'/field?page=1&search=&perPage=1000').then(({ data }) => {
        this.fields = data.data;
      });
    },
    loadRecords(){
      axios.get('/api/project/'+this.id+'/field?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
        this.fields = data.data;
        this.lastPage = data.last_page;
      });
    },
    loadCategories(){
      axios.get('/api/project/'+this.id+'/category?page=1&search=&perPage=1000').then(({ data }) => {
        this.categories = data.data;
      });
    }
  },
  created() {
    this.$Progress.start();
    this.loadRecords();
    this.loadCategories();
    this.$Progress.finish();
  }
}
</script>
